import { Header5, LinkButton, Paragraph3, Close16 as IconClose } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import { EPosition } from '../../../../filters/components/filters/filters';

import * as styles from './styles.css';
// @ts-ignore
import * as image from './waving.png';

interface ICoworkingPopup {
  className?: string;
  onClose(event: React.SyntheticEvent<HTMLButtonElement>): void;
  filtersPosition: EPosition;
}

export const CoworkingPopup: React.FC<ICoworkingPopup> = ({ className, onClose, filtersPosition }) => (
  <div
    className={classNames(styles['root'], className, {
      [styles['with-filters']]: filtersPosition === EPosition.Fixed,
      [styles['with-header']]: filtersPosition === EPosition.default,
    })}
  >
    <img src={image} className={styles['image']} />
    <button type="button" className={styles['button-close']} onClick={onClose}>
      <IconClose />
    </button>
    <Header5>У нас есть офисы в коворкингах!</Header5>
    <Paragraph3>И они уже оборудованы всем необходимым</Paragraph3>
    <div className={styles['link']}>
      <LinkButton
        size="XS"
        href="https://www.cian.ru/cat.php?coworking_offer_type%5B0%5D=1&deal_type=rent&engine_version=2&offer_type=offices&office_type%5B0%5D=1&region=1"
      >
        Посмотреть
      </LinkButton>
    </div>
  </div>
);

CoworkingPopup.displayName = 'CoworkingPopup';
